import { AUTH_HEADER } from '@/core/constants/http-headers'
import { IHttpClient } from '@/core/services/http'
import { ITokenService } from '@/core/services/tokens/token.service.interface'
import { ConfirmPaymentModel } from '../types/models/confirm-payment.model'

export function createConfirmPaymentUseCase({
  httpClient,
  tokenService,
}: {
  httpClient: IHttpClient
  tokenService: ITokenService
}) {
  return async function (input: ConfirmPaymentModel, isUpdate = false) {
    const { token, accountType } = await tokenService.getToken()
    const authHeader = token ? AUTH_HEADER(token) : {}
    const req = inputToJson(input)
    const endpoint = isUpdate
      ? `/website/${accountType}/confirmPaymentUpdate`
      : `/website/${accountType}/trip/confirmPayment`
    await httpClient.version('v1').addHeaders(authHeader).post(endpoint, req)
  }
}

function inputToJson(input: ConfirmPaymentModel) {
  return {
    transaction_id: input.transactionId,
    trip_id: input.tripId,
  }
}
